module.exports = __webpack_public_path__ + "img/ar.6a2c6670.svg";